export function isManuallyApproved(humanAccepted: string | null | undefined): boolean {
  return humanAccepted != null;
}
